export default "__VITE_ASSET__BnBP4HNy__"